import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ContextService } from '../../core/context/context.service';


@Injectable({
  providedIn: 'root'
})
export class BrandService {

  constructor(
    private http: HttpClient
  ) { }

  
  public getBrand(brand: string): any {
    return this.http.get(`${ environment.stores_brand }${ brand }`);
  }
}


